import { colors, fonts } from '@grupoboticario/flora-tokens/dist/beautybox/web/ds'

export const beautybox = {
  colors,
  fonts,
}
